<template>
  <div class="product">
    <div class="title">
      <h3 @click="goback()">
        <i class="el-icon-arrow-left"></i>
        <!--        {{ id ? '编辑产品' : '新增产品' }}-->
        {{ id ? $t("product.editproduct") : $t("product.addproduct") }}
        <span
          >{{ $t("common.required1") }}<i>*</i
          >{{ $t("common.required2") }}</span
        >
      </h3>
    </div>
    <div class="tixing">
      <h4>{{ $t("common.importantremind") }}</h4>
      <p>
        <!--        建议您在<i>2023年8月30日</i>前完成资料填写及上传。产品资料愈丰富，曝光机会愈多。-->
        {{ $t("common.suggest1") }}<i>{{ $t("product.date") }}</i
        >{{ $t("common.suggest2") }}{{ $t("common.suggest3") }}
      </p>
    </div>
    <div class="formData">
      <el-form
        ref="sizeForm"
        :model="sizeForm"
        label-width="170px"
        size="mini"
        :rules="rules"
      >
        <el-form-item :label="$t('product.nameCn') + ':'" prop="exhibitsName">
          <el-input
            v-model="sizeForm.exhibitsName"
            :placeholder="$t('common.placeholder') + $t('product.nameCn')"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('product.nameEn') + ':'" prop="column25">
          <el-input
            v-model="sizeForm.column25"
            :placeholder="$t('common.placeholder') + $t('product.nameEn')"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('product.type') + ':'" prop="column23">
          <el-input
            v-model="sizeForm.column23"
            :placeholder="$t('common.placeholder') + $t('product.type')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('product.class') + ':'"
          class="type"
          prop="column17"
        >
          <el-col :span="21">
            <el-cascader
              :placeholder="$t('common.placeholder') + $t('product.Keywords')"
              separator=" - "
              :options="keywordsLists"
              v-model="keyWords"
              @change="handleCascader"
              filterable
              clearable
            ></el-cascader>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="sizeForm.column17"
              :placeholder="$t('product.first')"
              @change="handleChange1"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="8">
            <el-select
              v-model="sizeForm.column18"
              :placeholder="$t('product.second')"
              @change="handleChange2"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7">
            <el-select
              v-model="sizeForm.column19"
              :placeholder="$t('product.third')"
              @change="handleChange3"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- <div class="search">
            <el-button type="primary" icon="el-icon-search">搜索</el-button>
          </div> -->
          <div class="menu">
            <div class="thead1">
              <h3>{{ $t("product.first") }}</h3>
              <h3>{{ $t("product.second") }}</h3>
              <h3>{{ $t("product.third") }}</h3>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('product.customclass') + ':'"
          class="custome"
          prop="column15"
        >
          <el-col :span="8">
            <el-select
              v-model="sizeForm.column15"
              :placeholder="$t('common.select')"
            >
              <el-option
                v-for="item in productType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <span @click="openDialog()">{{ $t("product.maintain") }}</span>
          <!--     维护产品系列弹窗     -->
          <el-dialog
            :title="$t('product.maintain')"
            :visible.sync="openPannel"
            width="30%"
            :before-close="handleClose"
            :close-on-click-modal="false"
          >
            <div class="container">
              <div class="main">
                <div class="remarks">{{ $t("product.remarks") }}</div>
                <div class="warnInfo">{{ $t("product.warnInfo") }}</div>
                <table
                  class="dataTabble"
                  ref="dataTable"
                  style="white-space: nowrap"
                >
                  <thead>
                    <tr>
                      <th style="width: 100px">{{ $t("common.order") }}</th>
                      <th style="width: 350px">
                        {{ $t("product.customclassname") }}
                      </th>
                      <th style="width: 60px">{{ $t("common.operate") }}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="serialList"
                    element="tbody"
                    :move="getdata"
                    @update="datadragEnd"
                    ref="draggable"
                  >
                    <tr v-for="(item, index) in serialList" :key="index">
                      <td><i class="el-icon-s-fold"></i></td>
                      <td>{{ item.name }}</td>
                      <td>
                        <i
                          class="el-icon-delete"
                          style="color: #006fb8"
                          @click="del(item, index)"
                          >{{ $t("common.delete") }}</i
                        >
                      </td>
                    </tr>
                    <tr v-if="addVisiable">
                      <td><i class="el-icon-s-fold"></i></td>
                      <td>
                        <el-input
                          v-model="addDragInput"
                          :placeholder="$t('product.customplaceholder')"
                          style="width: 200px"
                          @blur="onBlurInput"
                        ></el-input>
                      </td>
                      <td>
                        <i class="el-icon-delete" style="color: #006fb8">{{
                          $t("common.delete")
                        }}</i>
                      </td>
                    </tr>
                  </draggable>
                </table>
                <el-button @click="addDrag" class="add"
                  ><i class="el-icon-plus"></i>{{ $t("common.add") }}</el-button
                >
              </div>
              <div class="footer">
                <el-button @click="saveProductLists()">{{
                  $t("common.save")
                }}</el-button>
                <!-- <el-button type="primary" @click="viewSeries()">预览</el-button> -->
              </div>
            </div>
          </el-dialog>
          <!--     维护产品系列弹窗结束     -->
          <span
            style="height: 35px; display: inline-block"
            class="examine"
            id="card"
          >
            {{ $t("product.viewcustom") }}</span
          >
          <div class="shili" id="toggleCard" style="display: none">
            <h3>{{ $t("homepage.product") }}</h3>
            <div class="list_box">
              <div class="left">
                <h3>{{ $t("product.series") }}</h3>
                <ul>
                  <li
                    v-for="(ite, index) in product"
                    :key="index"
                    :class="(lang = 'en' ? 'teshu' : '')"
                    @mouseenter="entry(index)"
                  >
                    {{ ite }}
                  </li>
                </ul>
              </div>
              <div
                class="right"
                v-for="(item, index) in rightItem"
                :class="(lang = 'en' ? 'rightEnglish' : '')"
                :key="index"
              >
                <h2>{{ item.name }}</h2>
                <h4>{{ item.type }}</h4>
                <p>{{ item.categroy }}</p>
                <div class="img">
                  <img :src="item.imgUrl" alt="" />
                </div>
                <p>{{ item.company }}</p>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <p>
            <span style="margin-right: 0">*</span>{{ $t("product.remarks2") }}
          </p>
        </el-form-item>
        <!-- -------------------------------------------------------- -->
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('product.picture') + ':'"
              style="margin-top: 17px"
              prop="exhibitsImg"
            >
              <div class="imgBox">
                <ul>
                  <li v-for="(item, index) in productImgList" :key="index">
                    <div
                      :style="{
                        background:
                          'url(' +
                          item.url +
                          ')#f1f1f1 no-repeat center /contain',
                      }"
                      class="upload-logo"
                    >
                      <img
                        alt="删除"
                        src="../../../static/icon_del.png"
                        @click="delImg(index)"
                      />

                      <el-upload
                        :action="baseFileUrl"
                        ref="imgUpload"
                        :headers="getToken()"
                        :on-success="handSuccessExImg"
                        :limit="6"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                      >
                        <el-button
                          size="small"
                          style="margin: 0 auto"
                          @click="changeImgback(index)"
                          >{{ $t("common.selectfile") }}</el-button
                        >
                      </el-upload>
                    </div>
                  </li>
                </ul>

                <el-upload
                  drag
                  ref="imgUpload1"
                  class="upload-demo"
                  :action="baseFileUrl"
                  list-type="picture-card"
                  :on-remove="handleRemove"
                  :headers="getToken()"
                  :on-success="handSuccessExImg"
                  :before-upload="beforeUpload"
                  :show-file-list="false"
                  v-if="limitImg < 6"
                >
                  <div class="el-upload__text">
                    {{ $t("common.selectfile") }}
                  </div>
                </el-upload>
              </div>
              <p class="tishi">
                <!--                格式：jpg, png, gif; 建议尺寸：693*520px; 大小：2M内；最多上传6条，上传第一张为封面图-->
                {{
                  $t("common.uploadimg1", {
                    format: "jpg, png, gif",
                    recomsize: "693*520",
                    filesize: "2MB",
                  })
                }};
                {{ $t("common.uploadimg3") }}
              </p>
            </el-form-item>

            <el-form-item
              :label="$t('product.data') + ':'"
              prop="exhibitsAttach"
            >
              <el-upload
                class="upload-demo"
                :action="baseFileUrl"
                :headers="getToken()"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="6"
                :on-exceed="handleExceed"
                :on-success="handSuccessExhibits"
                :file-list="productfileList"
                :before-upload="beforeUploadFile"
              >
                <el-button size="small" class="select" type="primary">{{
                  $t("common.selectfile")
                }}</el-button>
                <div slot="tip" class="el-upload__tip">
                  {{ $t("common.uploadfile") }}
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          :label="$t('product.cnintroduce') + ':'"
          prop="exhibitsIntro"
        >
          <div class="editor">
            <tinymce-1
              ref="exhibitsIntro"
              :data="sizeForm.exhibitsIntro"
              :Num="100"
            ></tinymce-1>
          </div>
          <!-- <p>字数:还可以输入500字符，最多可输入300个字符（含标点及空格）</p> -->
        </el-form-item>
        <el-form-item
          :label="$t('product.enintroduce') + ':'"
          prop="exhibitsIntroE"
        >
          <div class="editor">
            <tinymce
              id="myedit"
              ref="exhibitsIntroE"
              v-model="sizeForm.exhibitsIntroE"
              :data="sizeForm.exhibitsIntroE"
              :Num="500"
            ></tinymce>
          </div>
          <!--          <p>字数:还可以输入150字符，最多可输入300个字符（含标点及空格）</p>-->
        </el-form-item>
        <el-form-item :label="$t('product.cnparameter') + ':'" prop="techParam">
          <div class="editor">
            <tinymce
              id="myedit"
              ref="techParam"
              v-model="sizeForm.techParam"
              :data="sizeForm.techParam"
              :Num="300"
            ></tinymce>
          </div>
          <!--          <p>字数:还可以输入500字符，最多可输入300个字符（含标点及空格）</p>-->
        </el-form-item>

        <el-form-item :label="$t('product.enparameter') + ':'" prop="column24">
          <div class="editor">
            <tinymce
              id="myedit"
              ref="column24"
              v-model="sizeForm.column24"
              :data="sizeForm.column24"
              :Num="300"
            ></tinymce>
          </div>
          <!--          <p>字数:还可以输入150字符，最多可输入300个字符（含标点及空格）</p>-->
        </el-form-item>
        <el-form-item :label="$t('product.videocover') + ':'" prop="column20">
          <!-- <el-upload
            drag
            ref="coverVideo"
            class="upload-demo"
            :action="baseFileUrl"
            list-type="picture-card"
            :on-remove="handleRemove"
            :headers="getToken()"
            :on-success="handSuccessVideo"
            :file-list="videoCoverList"
            :auto-upload="false"
          >
            <div class="el-upload__text">选择文件</div>
          </el-upload> -->
          <div class="imgBox">
            <ul>
              <li v-for="(item, index) in videoCoverList" :key="index">
                <div
                  :style="{
                    background:
                      'url(' + item.url + ')#f1f1f1 no-repeat center /contain',
                  }"
                  class="upload-logo"
                >
                  <img
                    alt="删除"
                    src="../../../static/icon_del.png"
                    @click="item.url = ''"
                  />

                  <el-upload
                    :action="baseFileUrl"
                    ref="coverVideo"
                    :headers="getToken()"
                    :on-success="handSuccessVideo"
                    :before-upload="beforeUpload"
                    :show-file-list="false"
                  >
                    <el-button
                      size="small"
                      style="margin: 0 auto"
                      @click="changeCoverback(index)"
                      >{{ $t("common.selectfile") }}</el-button
                    >
                  </el-upload>
                </div>
              </li>
            </ul>
            <el-upload
              drag
              ref="coverVideo"
              class="upload-demo"
              :action="baseFileUrl"
              list-type="picture-card"
              :on-remove="handleRemove"
              :headers="getToken()"
              :on-success="handSuccessVideo"
              :file-list="videoCoverList"
              :show-file-list="false"
              v-if="videoCoverList.length < 1"
            >
              <div class="el-upload__text">{{ $t("common.selectfile") }}</div>
            </el-upload>
          </div>
          <p class="tishi">
            <!--            格式：jpg, png, gif; 建议尺寸：800*450px; 大小：2M内-->
            {{
              $t("common.uploadimg1", {
                format: "jpg, png, gif",
                recomsize: "800*450",
                filesize: "500kb",
              })
            }}
          </p>
        </el-form-item>
        <el-form-item :label="$t('product.video') + ':'" prop="column21">
          <el-upload
            ref="videoUpload"
            class="upload-demo"
            :action="baseFileUrl"
            :headers="getToken()"
            :on-remove="handleRemove1"
            name="file"
            :on-success="handSuccessProductVideo"
            :file-list="videofileList"
            :limit="limitNumber"
            :before-upload="
              (file) => {
                return handleBefore(file, 'mp4', 'mov', 100);
              }
            "
          >
            <el-button size="small" class="select" type="primary">{{
              $t("common.selectfile")
            }}</el-button>
            <div slot="tip" class="el-upload__tip">
              <!--              格式：mp4, mov; 大小：100M内，只能上传一个文件-->
              {{
                $t("common.uploadvideo2", {
                  format: "mp4, mov",
                  filesize: "100M",
                })
              }}
            </div>
          </el-upload>
          <p>{{ $t("common.tips") }}</p>
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            class="submit"
            @click="submitAll('sizeForm')"
            >{{ $t("common.publish") }}</el-button
          >
          <el-button
            style="min-width: 77px; height: 28px; line-height: 5px"
            @click="viewDetail()"
            >{{ $t("common.preview") }}</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Tinymce from "../../comment/tinymce.vue";
import Tinymce1 from "../../comment/tinymce.vue";
import {
  addProduct,
  getSeriesLists,
  getProduct,
  editProduct,
  saveSeries,
} from "../../../../api/productCenter.js";
import draggable from "vuedraggable";
import { forMat, baseFileUrl } from "../../../../utils/common.js";
import products from "../../../../Json/searchLists.js"; //中文名称
import productsEn from "../../../../Json/searchListsEn"; //英文名称
import Head from "../../common/viewHead.vue";
import Foot from "../../common/foot.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import otherProduct from "./otherProduct.vue";
import { getExhition } from "../../../../api/exhibitor.js";

export default {
  data() {
    return {
      listArr: [],
      lang: "",
      limitImg: 0,
      limitNumber: 1,
      baseFileUrl: baseFileUrl(),
      baseUrl: forMat(),
      id: this.$route.query.id || "",
      //维护系列产品列表
      serialList: [],
      // 展示维护产品系列面板
      openPannel: false,
      // 显示搜索产品关键字面板
      cardVisiable: false,
      keyWords1: "",
      keyWords2: "",
      keyWords3: "",
      keyWords: [],

      // 产品关键字
      sizeForm: {
        id: "",
        exhibitsName: "", //产品名称
        column25: "", //产品名称-英文
        column23: "", //产品型号
        column15: "", //产品系列
        column20: "", //产品宣传视频封面地址
        column21: "", //上传视频中文地址
        exhibitsAttach: "", //产品资料可上传多个
        exhibitsImg: "", //展品图，多张图片用逗号隔开
        exhibitsIntro: "", //展品介绍-中
        exhibitsIntroE: "", //展品介绍-英
        techParam: "", //	展品参数-中文
        column24: "", //展品参数-英文
        exhibitsType: "", //一级分类|二级分类|三级分类",
        column16: "", //'产品资料名称,多个用逗号隔开'
        column17: "", //一级分类
        column18: "", //二级分类
        column19: "", //三级分类
        exhibitsCoverImg: "", //"展品封面图，默认为展品图的第一张",
      },

      swiperOption: {
        loop: true,
        autoplay: true,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      exhibitorInfo: {
        companyNameC: "", // 中文名称
        comCover: "", //公司Logo
        boothList: [], //展位号
      },

      options1: [],
      options2: [],
      options3: [],
      //产品类型维护
      productType: [],

      imgArr: [
        { imgUrl: require("@/static/indexBanner.png") },
        { imgUrl: require("@/static/indexBanner.png") },
        { imgUrl: require("@/static/indexBanner.png") },
      ],

      fileMoveList: [{}],
      //已经上传的文件列表

      productfileList: [],
      // 展品图片列表

      productImgList: [],
      // 宣传视频封面

      videoCoverList: [],
      // 产品视频

      videofileList: [],
      flag: true,
      disabled: false,

      //产品系列列表
      product: [
        this.$t("product.allProduct"),
        this.$t("product.chengtao"),
        this.$t("product.shusong"),
        this.$t("product.zhihu"),
        this.$t("product.caimei"),
        this.$t("product.juemiao"),
        this.$t("product.quanzid"),
        this.$t("product.zuanji"),
      ],

      dataSource: [
        {
          name: this.$t("product.productName"),
          type: "EBH300A",
          categroy: this.$t("product.categroy1"),
          imgUrl: require("@/static/product1.png"),
          company: "中国煤矿机械装备有限责任公司",
        },

        {
          name: this.$t("product.chengtao"),
          type: "ZF8000/22/35",
          categroy: this.$t("product.categroy"),
          imgUrl: require("@/static/product2.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.shusong"),
          type: this.$t("product.procuctName1"),
          categroy: this.$t("product.categroy1"),
          imgUrl: require("@/static/product3.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.zhihu"),
          type: this.$t("product.productName2"),
          categroy: this.$t("product.categroy"),
          imgUrl: require("@/static/product4.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.caimei"),
          type: this.$t("product.productName3"),
          categroy: this.$t("product.categroy"),
          imgUrl: require("@/static/product5.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.juemiao"),
          type: "EBH300A岩石掘进机",
          categroy: this.$t("product.categroy1"),
          imgUrl: require("@/static/product7.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.quanzid"),
          type: this.$t("product.quanzid"),
          categroy: this.$t("product.categroy1"),
          imgUrl: require("@/static/product8.png"),
          company: "中国煤炭机械装备有限责任公司",
        },

        {
          name: this.$t("product.dianji"),
          type: this.$t("product.productName4"),
          categroy: this.$t("product.categroy2"),
          imgUrl: require("@/static/product2.png"),
          company: "中国煤炭机械装备有限责任公司",
        },
      ],
      isActive: 0, //标志索引
      rightItem: [], //右边的绑定的内容数组
      showDiag: false, // 显示产品维护示例
      keywordsLists: null,
      addVisiable: false,
      addDragInput: "",
      toggleImg: "",
      currentIndex: "",
      currentCoverIndex: "",
      viewData: "",
      zsId: "",
      lunboImg: [],
      viewColumn15: "",
      // rules: {

      // },
      isHasFile: false,
      isHasVideo: false,
    };
  },

  components: {
    Tinymce,
    Tinymce1,
    draggable,
    Head,
    swiper,
    swiperSlide,
    otherProduct,
    Foot,
  },

  created() {
    if (localStorage.getItem("lang") == "en") {
      this.keywordsLists = productsEn;
      this.lang = "en";
    } else {
      this.keywordsLists = products;
      this.lang = "zn";
    }

    this.rightItem.push(this.dataSource[this.isActive]);
    this.getItem();
    this.productsSeries();
    this.getScreenLists();
    if (this.id) {
      this.flag = false;
      this.limitNumber = 2;
    }
  },

  watch: {
    "$i18n.locale"(newValue) {
      if (this.$i18n.locale === "zh") {
        this.keywordsLists = products;
        location.reload();
      } else if (this.$i18n.locale === "en") {
        this.keywordsLists = productsEn;
        location.reload();
      }
    },
  },
  mounted() {
    this.toggleCard();
  },
  computed: {
    rules() {
      var validatorExImg = (rule, value, callback) => {
        if (this.productImgList.length < 1) {
          callback(new Error(this.$t("product.rules.message1")));
        } else {
          callback();
        }
      };

      var validatorIntro = (rule, value, callback) => {
        const content = this.$refs.exhibitsIntro.getContent();
        let enterNum = this.$refs.exhibitsIntro.removeHTMLTag(content).length;
        if (!content) {
          return callback(new Error(this.$t("product.rules.message2")));
        } else if (enterNum > 500) {
          return callback(new Error(this.$t("product.rules.message3")));
        } else {
          return callback();
        }
      };

      var validatorIntroE = (rule, value, callback) => {
        const content = this.$refs.exhibitsIntroE.getContent();
        let enterNum = this.$refs.exhibitsIntroE.removeHTMLTag(content).length;
        if (enterNum > 300) {
          return callback(new Error(this.$t("product.rules.message4")));
        } else {
          return callback();
        }
      };

      var validatortechParam = (rule, value, callback) => {
        const content = this.$refs.techParam.getContent();
        let enterNum = this.$refs.techParam.removeHTMLTag(content).length;
        if (enterNum > 500) {
          return callback(new Error(this.$t("product.rules.message5")));
        } else {
          return callback();
        }
      };
      var validatorcolumn24 = (rule, value, callback) => {
        const content = this.$refs.column24.getContent();
        let enterNum = this.$refs.column24.removeHTMLTag(content).length;
        if (enterNum > 300) {
          return callback(new Error(this.$t("product.rules.message6")));
        } else {
          return callback();
        }
      };
      return {
        exhibitsName: [
          { required: true, message: this.$t("product.rules.tishi1") },
        ],

        // column23: [{ required: true, message: '产品型号不能为空' }],
        column15: [
          { required: true, message: this.$t("product.rules.tishi2") },
        ],
        column17: [
          { required: true, message: this.$t("product.rules.tishi3") },
        ],
        exhibitsImg: [
          {
            validator: validatorExImg,
            trigger: "change",
            message: this.$t("product.rules.tishi4"),
            required: true,
          },
        ],
        exhibitsIntro: [
          { validator: validatorIntro, trigger: "blur", required: true },
        ],
        exhibitsIntroE: [{ validator: validatorIntroE, trigger: "blur" }],
        techParam: [{ validator: validatortechParam, trigger: "blur" }],
        column24: [{ validator: validatorcolumn24, trigger: "blur" }],
      };
    },
  },

  methods: {
    handleRemove1(file, fileList) {
      this.$refs.videoUpload.clearFiles();
      this.videofileList = [];
      this.sizeForm.column21 = "";
      // console.log(this.videofileList);
    },
    beforeUploadFile(file) {
      // 1mb = 1024kb
      const fileSize = file.size / 1024 / 1024 < 20;
      if (!fileSize) {
        this.$message.error(this.$t("product.rules.tishi5"));
        return false;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    // 获取展商信息
    async getExhibitorInfo(id) {
      const params = { id };
      try {
        const { data } = await getExhition(params);
        this.exhibitorInfo = data.data;
        var arr = [];
        data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exhibitorInfo.boothList = arr;
      } catch (err) {
        console.log(err);
      }
    },
    viewDetail() {
      this.viewData = this.sizeForm;
      const urlString = this.sizeForm.exhibitsAttach.slice(1);
      const nameString = this.sizeForm.column16.slice(1);
      const urlArr = urlString.split(",");
      const nameArr = nameString.split(",");

      if (urlString == "" && nameString == "") {
        this.listArr = [];
      } else {
        this.listArr = [];
        urlArr.map((item) => {
          nameArr.map((it) => {
            if (item.includes(it)) {
              this.listArr.push({
                name: it,
                url: item,
              });
            }
          });
        });
      }
      var str1 = "";
      this.videoCoverList.map((item) => {
        str1 = item.url;
      });
      this.sizeForm.column20 = str1.slice(28);
      const result = this.productType.filter(
        (it) => it.value === this.sizeForm.column15
      );
      if (result.length != 0) {
        this.viewColumn15 = result[0].label;
      }
      const params = {
        sizeForm: this.sizeForm,
        lunboImg: this.productImgList,
        zsId: this.zsId,
        exhibitsIntro: this.$refs.exhibitsIntro.getContent(),
        exhibitsIntroE: this.$refs.exhibitsIntroE.getContent(),
        techParam: this.$refs.techParam.getContent(),
        column24: this.$refs.column24.getContent(),
        listArr: this.listArr,
        column20: this.sizeForm.column20,
        viewColumn15: this.viewColumn15,
        id: this.id,
      };
      this.$store.commit("updateparams", params);
      let { href } = this.$router.resolve({
        name: "viewproduct",
      });
      window.open(href, "_blank");
    },

    beforeRemove(file, fileList) {
      this.sizeForm.exhibitsAttach = "";
      this.sizeForm.column16 = "";
      this.$confirm(`确定移除 ${file.name}?`).then((res) => {
        if (res === "confirm") {
          fileList.map((item) => {
            // console.log('移除文件内容的', item);
            const url = item.response.data.url;
            this.sizeForm.exhibitsAttach += "," + url;
            this.sizeForm.column16 += "," + item.name;
          });
        }
      });
    },

    getElement(id) {
      return document.getElementById(id);
    },

    stopBubble(e) {
      if (e && e.stopPropagation) {
        e.stopPropagation(); //w3c
      } else {
        window.event.cancelBubble = true; //IE
      }
    },

    toggleCard() {
      const div = this.getElement("card");
      const div1 = this.getElement("toggleCard");
      div.onclick = (event) => {
        div1.style.display = "block";
        this.stopBubble(event);
        document.onclick = function () {
          div1.style.display = "none";
          document.onclick = null;
        };
      };
    },

    goback() {
      this.$router.push("/backIndex/productIndex");
    },

    changeCoverback(index) {
      this.currentCoverIndex = index;
    },

    changeImgback(index) {
      this.currentIndex = index;
    },

    handleBefore(file) {
      const fileSize = file.size / 1024 / 1024 < 100;
      if (["video/mp4", "video/mov"].indexOf(file.type) === -1) {
        this.$message.error(this.$t("product.rules.tishi6"));
        return false;
      }
      if (!fileSize) {
        this.$message.error(this.$t("product.rules.tishi9"));
        return false;
      }
    },

    //上传前校验
    beforeUpload(file) {
      let filehz = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀

      if (filehz !== "jpg" && filehz !== "png" && filehz !== "gif") {
        this.$message({
          message: this.$t("product.rules.tishi7"),
          type: "warning",
        });
        return false;
      }
      const limitSize = file.size / 1024 < 2048;
      if (!limitSize) {
        this.$message({
          message: this.$t("product.rules.tishi8"),
          type: "warning",
        });
        return false;
      }
    },

    onBlurInput() {
      this.addVisiable = false;
      const length = this.serialList.length;
      this.serialList.push({
        name: this.addDragInput,
        sort: length,
      });
      this.addDragInput = "";
    },

    addDrag() {
      this.addVisiable = true;
    },

    // 产品关键字变化时
    handleCascader() {
      this.sizeForm.column17 = this.keyWords[0];
      this.sizeForm.column18 = this.keyWords[1];
      this.sizeForm.column19 = this.keyWords[2];
      this.handleChange1();
      this.handleChange2();
    },

    // 获取单个产品信息
    async getItem() {
      if (this.id) {
        // this.flag = false
        const params = {
          id: this.id,
        };
        try {
          const { data } = await getProduct(params);

          if (data.code === 200) {
            const itemData = data.data;
            this.sizeForm = itemData;
            this.zsId = data.data.hzExhibitorId;

            const {
              exhibitsAttachList,
              exhibitsImg,
              column20,
              column21,
              column17,
              column18,
              column19,
            } = itemData;
            this.keyWords = [column17, column18, column19];
            // if (column17 == '其他产品类别') this.keyWords = column17;
            this.handleChange1();
            this.handleChange2();

            // 展品图片列表
            const proList = exhibitsImg.split(",");

            proList.map((item) => {
              if (item !== "") {
                const imgName = item.match(/\/([^/]*)$/)[1].slice(13);
                this.productImgList.push({
                  url: `${item.includes("http") ? "" : this.baseUrl}${item}`,
                  name: imgName,
                });
              }
            });
            // exhibitsAttachList产品资料
            exhibitsAttachList.map((item) => {
              const imgUrl = this.baseUrl + item.url;
              this.productfileList.push({
                url: imgUrl,
                name: item.name,
              });
            });
            // 宣传视频封面
            const myRe = /^.*\/\d{13}(.*)$/g;
            const coverImg = myRe.exec(column20);
            if (coverImg === null) {
              this.videoCoverList = [];
            } else if ((coverImg.length = 2)) {
              this.videoCoverList.push({
                name: coverImg[1],
                url: this.baseUrl + column20,
              });
            }

            // 产品视频列表
            const proVideoList = column21.match(/\/([^/]*)$/)[1].slice(13);
            this.videofileList.push({
              url: this.baseUrl + column21,
              name: proVideoList,
            });
          }
        } catch (err) {
          // this.$message.error(err);
        }
      }
    },

    handleChange1() {
      // console.log(this.sizeForm.column17);
      if (this.sizeForm.column17) {
        if (this.sizeForm.column17 == "其他产品类别") {
          this.options2 = "";
          this.options3 = "";
          this.sizeForm.column18 = "";
          this.sizeForm.column19 = "";
          this.keyWords = this.sizeForm.column17;
        } else {
          const data = this.keywordsLists.filter(
            (it) => this.sizeForm.column17 === it.value
          );
          this.keyWords1 = data[0].value;
          this.options2 = [];
          data.map((item) => {
            if (item.children) {
              item.children.map((i) => {
                this.options2.push({
                  value: i.value,
                  label: i.label,
                });
              });
            }
          });
          console.log(this.options2);
        }
      }
    },

    handleChange2() {
      if (this.sizeForm.column18) {
        const data = this.keywordsLists.filter(
          (it) => this.sizeForm.column17 === it.value
        );
        const data2 = data[0].children.filter(
          (it) => it.value === this.sizeForm.column18
        );
        this.keyWords2 = data2[0].value;
        this.options3 = [];
        data2.map((item) => {
          if (item.children) {
            item.children.map((i) => {
              this.options3.push({
                value: i.value,
                label: i.label,
              });
            });
            console.log("handleChange2d的值", this.options3);
          }
        });
      }
    },

    handleChange3() {
      const { column17, column18, column19 } = this.sizeForm;

      if (column19) {
        const data = this.keywordsLists.filter((it) => column17 === it.value);
        const data2 = data[0].children.filter((it) => it.value === column18);
        const data3 = data2[0].children.filter((it) => it.value === column19);
        this.keyWords3 = data3[0].value;
      }
      this.keyWords = [this.keyWords1, this.keyWords2, this.keyWords3];
    },

    // 获取筛选分类的函数
    getScreenLists() {
      // console.log("keywordsLists得数据");
      this.keywordsLists.map((item) => {
        this.options1.push({
          value: item.value,
          label: item.label,
        });
      });
      // console.log("获取到的数据",this.options1);
    },

    //拖动中与拖动结束
    getdata(evt) {
      // console.log(evt.draggedContext.element);
    },

    datadragEnd(evt) {
      // console.log('拖动前的索引 :' + evt.oldIndex);
      // console.log('拖动后的索引 :' + evt.newIndex);
      // console.log(evt);
    },

    // 产品视频上传成功函数
    handSuccessProductVideo(file) {
      if (file.code === 200) {
        const { url, name } = file.data;
        this.sizeForm.column21 = url;
        this.isHasVideo = true;
        this.videofileList = [
          {
            name: name,
            url: url,
          },
        ];
        // console.log(this.sizeForm.column21)
        // this.$nextTick(() => {
        //   this.$refs.sizeForm.clearValidate('column21');
        // });
      }
    },

    // 宣传视频封面上传成功函数
    handSuccessVideo(file) {
      if (file.code == 200) {
        const { url, name } = file.data;

        if (url.indexOf("http") == -1) {
          url = this.baseUrl + url;
        }

        if (this.currentCoverIndex !== "") {
          // 修改封面的url
          const currentChangeCover = this.videoCoverList.filter(
            (it, index) => index === this.currentCoverIndex
          );

          currentChangeCover[0].url = url;
        } else {
          // 新增封面
          this.videoCoverList.push({
            name: name,
            url: url,
          });
        }
        this.currentCoverIndex = "";

        // this.$nextTick(() => {
        //   this.$refs.sizeForm.clearValidate('column20');
        // });
      }
    },

    progreess(file) {
      // console.log('progeress',file);
    },

    // 产品资料上传成功函数
    handSuccessExhibits(file) {
      if (file.code == 200) {
        const { url, name } = file.data;
        this.sizeForm.exhibitsAttach += "," + url;
        this.sizeForm.column16 += "," + name;
        this.isHasFile = true;

        // this.$nextTick(() => {
        //   this.$refs.sizeForm.clearValidate('exhibitsAttach');
        // });
      }
    },

    error(err, file, fileList) {
      // console.log(err)
      // console.log(file,fileList);
    },

    // 展品图片上传成功函数
    handSuccessExImg(file) {
      if (file.code == 200) {
        const { url, name } = file.data;

        this.limitImg += 1;
        if (this.currentIndex !== "") {
          // 修改当前选择的文件
          const currentChangeImg = this.productImgList.filter(
            (it, index) => index === this.currentIndex
          );
          currentChangeImg[0].url = this.baseUrl + url;
        } else {
          // 新增的图片文件
          if (url.indexOf("http") == -1) {
            url = this.baseUrl + url;
          }

          this.productImgList.push({
            name: name,
            url: url,
          });

          // console.log('打印的数组是:', this.productImgList);
        }
        // this.$nextTick(() => {
        //   this.$refs.sizeForm.clearValidate('exhibitsImg');
        // });
      }
      this.currentIndex = "";
    },

    delImg(currentdelIndex) {
      this.productImgList.splice(currentdelIndex, 1);
      this.limitImg -= 1;
      console.log("12333", this.$refs.imgUpload);
    },

    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },

    async saveProductLists() {
      //获取产品系列保存
      this.serialList.map((item, index) => {
        item.sort = index;
      });
      try {
        const { data } = await saveSeries(this.serialList);
        if (data.code === 200) {
          this.openPannel = false;
          this.productsSeries();
        }
      } catch (err) {
        this.$message.error(err);
      }
    },

    handleClose() {
      this.openPannel = false;
      this.serialList = [];
    },

    async openDialog() {
      this.openPannel = true;
      this.serialList = [];
      // 获取维护产品系列列表
      const { data } = await getSeriesLists();
      const lists = data.data;
      lists.map((item, index) => {
        this.serialList.push({
          id: item.id,
          name: item.name,
          sort: index,
        });
      });
    },

    onFoucs() {
      this.cardVisiable = true;
    },

    onBlur() {
      this.cardVisiable = false;
    },

    handleRemove(file, fileList) {
      // const { url, status } = file;
      // if (status === 'success') {
      //   const currentUrl = url.toString().substr(25);
      //   const arr = this.sizeForm.exhibitsImg.split(',');
      //   arr.map((item, index) => {
      //     if (item === currentUrl) {
      //       arr.splice(index, 1);
      //     }
      //   });
      //   this.sizeForm.exhibitsImg = arr.toString();
      // }
    },

    handlePreview(file) {
      // console.log(file);
    },

    handleChange(file, fileList) {
      const arr = fileList;
      if (this.id) {
        fileList.shift();
      }
      // console.log(fileList,file)
    },

    //鼠标移开执行
    entry(index) {
      this.rightItem = [];
      this.isActive = index;
      this.rightItem.push(this.dataSource[this.isActive]);
    },

    toggle() {
      //鼠标悬浮
      this.showDiag = !this.showDiag;
    },

    // leave() {
    //   //鼠标离开
    //   this.showDiag = true;
    // },

    del(item, index) {
      this.serialList.splice(index, 1);
    },

    submitAll(formName) {
      this.$refs["sizeForm"].validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message.error(this.$t("product.rules.tishi10"));
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
      });
    },
    format(str) {
      let index = str.indexOf("/hz/");
      str = str.substring(index, str.length);
      return str;
    },
    async submitForm() {
      this.sizeForm.exhibitsIntro = this.$refs.exhibitsIntro.getContent();
      this.sizeForm.exhibitsIntroE = this.$refs.exhibitsIntroE.getContent();
      this.sizeForm.techParam = this.$refs.techParam.getContent();
      this.sizeForm.column24 = this.$refs.column24.getContent();
      var str = "";
      // console.log('图片为处理提交上来的数组', this.productImgList);
      this.productImgList.map((item) => {
        let path1 = this.format(item.url);
        str += "," + path1;

        // str += ',' + item.url.slice;
      });
      this.sizeForm.exhibitsImg = str.substr(1);
      const arr = str.substr(1).split(",");
      this.sizeForm.exhibitsCoverImg = arr[0];
      this.sizeForm.exhibitsType =
        this.sizeForm.column17 +
        "|" +
        this.sizeForm.column18 +
        "|" +
        this.sizeForm.column19;
      let message;
      const first = this.sizeForm.exhibitsAttach.substring(0, 1);
      if (first === ",") {
        message = this.sizeForm.exhibitsAttach.substr(1);
      } else {
        message = this.sizeForm.exhibitsAttach;
      }
      this.sizeForm.exhibitsAttach = message;
      const name = this.sizeForm.column16.substring(0, 1);
      let messageName;
      if (name === ",") {
        messageName = this.sizeForm.column16.substr(1);
      } else {
        messageName = this.sizeForm.column16;
      }
      this.sizeForm.column16 = messageName;
      var str1 = "";
      this.videoCoverList.map((item) => {
        let path1 = this.format(item.url);
        str1 = path1;
      });
      this.sizeForm.column20 = str1;
      delete this.sizeForm.hzExhibitor;
      if (this.id) {
        this.sizeForm.id = this.id;
        // console.log(this.sizeForm.column21)
        try {
          const { data } = await editProduct(this.sizeForm);
          if (data.code === 200) {
            this.$router.push("/backIndex/productIndex");
          }
        } catch (err) {
          this.$message.error(this.$t("product.rules.tishi11"));
        }
      } else {
        try {
          const { data } = await addProduct(this.sizeForm);
          if (data.code === 200) {
            this.$router.push("/backIndex/productIndex");
          }
        } catch (err) {
          this.$message.error(this.$t("product.rules.tishi12"));
        }
      }
    },

    async productsSeries() {
      this.productType = [];
      const { data } = await getSeriesLists();
      const lists = data.data;
      lists.map((item) => {
        this.productType.push({
          value: item.id,
          label: item.name,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.teshu {
  line-height: 15px;
}
.rightEnglish {
  font-size: 12px;
  line-height: 18px;
  h2 {
    font-size: 14px !important;
  }
}
.editor {
  width: 800px;
}
.viewPage {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  .icon {
    top: 120px;
    position: absolute;
    right: 35px;
    font-size: 25px;
    color: #333;
  }
  h3 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 28px;
    color: #006fb8;
    border-left: 3px solid #006fb8;
    border-right: 3px solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .content {
    width: 100%;
    box-sizing: border-box;
    padding-left: 275px;
    padding-right: 275px;
    .parduct_intr {
      display: flex;
      margin-top: 42px;
      .lunbo {
        width: 692px;
        height: 520px;
        // border: 1px solid red;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        img {
          width: 100%;
          height: 424px;
          margin-top: 48px;
        }
        .swiper-container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        .swiper-container .swiper-slide {
          width: 100%;
          line-height: 200px;
          //   background: yellowgreen;
          color: #000;
          font-size: 16px;
          text-align: center;
        }
        .swiper-button-prev {
          background-image: url("../../../static/ico-leftprev.png");
        }
        .swiper-button-next {
          background-image: url("../../../static/ico-rightNex.png");
        }
      }
      .introduce {
        width: 490px;
        height: 520px;
        margin-left: 86px;
        // border: 1px solid red;
        box-sizing: border-box;
        padding: 24px 0 0 0;
        .title {
          width: 431px;
          h3 {
            height: 31px;
            font-size: 30px;
            line-height: 31px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            border: none;
          }
          .border {
            width: 100%;
            height: 3px;
            background: #006fb8;
          }
        }

        p {
          margin-top: 20px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;

          color: #333333;
        }
        .collent_btn {
          .shoucang {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #006fb8;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            margin: 18px 11px 0 0;
          }
          .shoucang:hover {
            background: #338cc6;
            cursor: pointer;
          }
          // .shoucang:active {
          //   background: #0064a6;
          // }
          .shoucang2 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #fdd000;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            //   margin: 22px 0 0 50px;
          }

          .shoucang2:hover {
            border: 1px solid transparent;
            background: #fdd933;
            cursor: pointer;
          }

          .shoucang3 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            background: #ededed;
            border-radius: 4px;
          }
          .shoucang3:hover {
            border: 1px solid transparent;
            background: #ededed;
            cursor: pointer;
          }
        }
        .exhibitor {
          width: 489px;
          height: 136px;
          display: flex;
          margin-top: 104px;
          border: 1px solid #e0e0e0;
          .logo {
            width: 237px;
            height: 136px;
            padding: 0 56px;
            box-sizing: border-box;
            border: 1px solid #e0e0e0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .exhi_title {
            box-sizing: border-box;
            padding-left: 20px;
            p {
              margin-top: 20px;
            }
          }
        }
      }
    }
    .product_content {
      margin-top: 100px;
      .content {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 27px;
        margin-top: 27px;
        text-indent: 2em;
      }
      .vedio {
        width: 800px;
        height: 450px;
        margin: 0 auto;
        margin-top: 42px;
        // border: 1px solid red;
      }
      .shipin {
        width: 100%;
        height: 450px;
      }
      p {
        text-indent: 2em;
      }
    }
    .produce_table {
      margin-top: 100px;
      .top {
        height: 40px;
        background: #006fb8;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        .el-row {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .grid-content {
          border-radius: 4px;
          min-height: 36px;
        }
        .row-bg {
          padding: 10px 0;
          background-color: #f9fafc;
        }
      }
    }
    //产品宣传下载资料
    .download {
      margin-top: 100px;
      .hstyle {
        width: 214px;
      }
      .down_box {
        .down_thend {
          display: flex;
          height: 40px;
          color: white;
          background-color: #fdd000;
          align-items: center;
          padding: 0px 30px;
          justify-content: space-between;
          p :first-child {
            width: 800px;
          }
        }
        .down_file {
          background-color: white;
          color: #333;
          border-bottom: 1px solid #e0e0e0;
          height: 51px;
        }
        a {
          text-decoration: none;
          color: #006fb8;
        }
      }
    }
  }
}
.imgBox {
  width: 470px;
  height: 100%;
  z-index: 9999;
  ul {
    overflow: hidden;
  }
  .upload-logo {
    text-align: center;
    width: 225px;
    height: 173px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .tishi {
    margin-top: 30px;
    width: 509px;
  }
}

.el-cascader {
  width: 460px;
}
.product {
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background: white;
  ul li {
    list-style-type: none;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .title {
    height: 55px;
    margin-left: 10px;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }
  .tixing {
    margin-left: 26px;
    background: #f6f6f7;
    padding: 10px 30px;
    margin-top: 16px;
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 19px;
      margin-bottom: 9px;
      //margin-top: 26px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  .formData {
    width: 730px;
    // margin: 0 auto;
    margin-top: 17px;
    .boxCard {
      margin-top: 10px;
      width: 600px;
      .title {
        width: 100%;
        height: 42px;
        background: #006fb8;
        border-radius: 2px 2px 0px 0px;
        ul li {
          float: left;
          width: 30%;
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
          line-height: 42px;
        }
      }
      .container {
        padding: 20px 30px;
        box-sizing: border-box;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: skyblue;
      // border: 1px solid red;
      width: 318px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 19px;
      span {
        color: red;
      }
    }
    .select {
      display: block;
      font-style: normal;
      width: 108px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .select1 {
      margin: 0 auto;
    }
    .box {
      width: 175px;
      height: 175px;
      // border: 1px solid red;
      background: #f1f1f1;
      display: flex;
      align-items: center;
    }
    .ceshi {
      width: 420;
      // border: 1px solid;
    }
    .menu {
      width: 520px;
      height: 209px;
      border: 1px solid red;
      position: relative;
      z-index: 99;
      display: none;
      top: 9px;

      .thead1 {
        width: 100%;
        height: 36px;
        background: #006fb8;
        display: flex;
        h3 {
          flex: 1;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
          line-height: 38px;
        }
      }
      .liandong {
        margin-top: 22px;
      }
    }
    span {
      margin-right: 18px;
      color: #006fb8;
      cursor: pointer;
    }
    .tishi {
      margin-top: 30px;
      width: 528px;
    }
    .select {
      display: block;
      font-style: normal;
      color: #666666;
      width: 118px;
      height: 28px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .custome {
      position: relative;
      .shili {
        width: 457px;
        height: 383px;
        position: absolute;
        background: #f6f6f7;
        box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.08),
          0px 8px 3px 0px rgba(0, 0, 0, 0.05),
          0px 10px 42px 14px rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        // border: 1px solid red;
        left: 259px;
        top: 26px;
        z-index: 99;
        box-sizing: border-box;
        padding: 17px 26px 26px 26px;
        h3 {
          width: fit-content;
          height: 24px;
          border-left: 2px solid #006fb8;
          border-right: 2px solid #006fb8;
          line-height: 24px;
          text-align: center;
        }
        .list_box {
          display: flex;
          height: 300px;
          margin-top: 17px;
          .left {
            width: 173px;

            h3 {
              width: 100%;
              height: 38px;
              box-sizing: border-box;
              line-height: 38px;
              color: white;
              font-size: 14px;
              background: #006fb8;
              text-align: left;
              padding-left: 17px;
              font-weight: 500;
            }
            ul {
              margin-left: 17px;
              li {
                margin-top: 5px;
                font-size: 12px;
              }
              li:hover {
                color: #006fb8;
                cursor: pointer;
              }
            }
          }
          .right {
            width: 215px;
            height: 298px;
            box-sizing: border-box;
            padding: 17px;
            margin-left: 17px;
            border: 1px solid #e0e0e0;

            h2 {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
            .img {
              margin: 17px 0 17px 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .submit {
      min-width: 77px;
      height: 28px;
      background: #006fb8;
      line-height: 5px;
      margin-bottom: 15px;
      margin-left: 168px;
    }
  }
}
.el-dialog .container {
  padding-bottom: 10px;
  box-sizing: border-box;
  .main {
    padding: 20px 30px;
    box-sizing: border-box;
    .remarks {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
    }
    .warnInfo {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 22px;
      margin-top: 10px;
    }
    table {
      margin-top: 20px;
      // border-bottom: ;
      thead {
        width: 520px;
        height: 42px;
        background: #fdc400;
        border-radius: 4px 4px 0px 0px;
        tr th {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
      }
      tbody {
        tr {
          height: 60px !important;
          border-bottom: 1px solid #e8e8e8 !important;
        }
      }
    }
    .add {
      width: 100%;
      height: 28px;
      border: 1px dashed #006fb8;
      background: white;
      color: #006fb8;
      margin-top: 20px;
    }
  }
  .footer {
    margin-top: 30px;
    border-top: 1px solid #e8e8e8;
    padding-top: 10px;
    padding-right: 30px;
    box-sizing: border-box;
    text-align: right;

    .el-button:nth-child(1) {
      width: 65px;
      height: 32px;
      background: #006fb8;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
    }
    .el-button:nth-child(2) {
      width: 65px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
    }
  }
}

.product ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
<style scoped>
.el-dialog__wrapper >>> .el-dialog__header {
  padding: 15px 20px 10px;
  background: #006fb8;
}
.el-dialog__wrapper >>> .el-dialog__title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__close {
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 0;
}
.search >>> .el-button {
  background: white;
  border: none;
  height: 28px;
  width: 69px;
  font-size: 12px;
  color: #006fb8;
  float: right;
  /* border: 1px solid red; */
  padding-right: 15px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-right: 0;
  border-left: 0px;
  position: absolute;
  right: 5px;
  top: 1px;
}
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 93px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
.ceshi >>> .el-input__inner {
  border-right: 0px;
}
.type >>> .el-form-item {
  position: relative;
}
.formData >>> .el-col-21 {
  margin-bottom: 22px;
}
.formData >>> .el-col-8 {
  margin-right: 7px;
}
.upload >>> .el-upload-dragger {
  width: 360px;
  height: 32px;
  border: none;
}
.upload-demo >>> .el-upload__text {
  width: 108px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
<style scoped>
.el-table >>> td {
  border-bottom: 1px solid #ebeef5;
  border-right: 0px;
  border-left: 0px;
  text-align: center;
}
.el-table >>> table {
  border: 0px;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(3n-1) {
  background: #e0e0e0;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(2n + 1) {
  background: #e0e0e0;
}
.tableDate >>> td:nth-child(1) {
  display: table-cell;
  text-align: center;
  align-items: center;
}
</style>
